import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable camelcase */
import React from "react";
import { Add, Remove } from "@mui/icons-material";
import styles from "./style.module.css";
export const getAmount = (shortName, options) => options.filter((item) => item.short_name === shortName).length;
/*
 * Subscription Flavor Option Component
 */
const SubscriptionFlavorOption = ({ full_name, image_url, onChange, short_name, maxedOut, flavorAmount, isProtein = false, out_of_stock = false, selectedOptions, }) => {
    function onChangeAmount(isAddButton) {
        if (isAddButton) {
            onChange(flavorAmount + 1, short_name);
        }
        else {
            if (flavorAmount === 0) {
                return;
            }
            onChange(flavorAmount - 1, short_name);
        }
    }
    function selectFlavor() {
        const selectedOption = selectedOptions.find((item) => item.short_name === short_name);
        if (selectedOption && !selectedOption.count) {
            const unSelectedOption = selectedOptions.find((item) => item.short_name !== short_name);
            if (unSelectedOption && selectedOption) {
                onChange(0, unSelectedOption.short_name);
                onChange(1, selectedOption?.short_name);
            }
        }
    }
    return (_jsxs("div", { className: styles.flavor_option, children: [_jsx("img", { className: styles.flavor_option_image, src: image_url, alt: "" }), _jsxs("div", { className: styles.flavor_option_info, children: [_jsx("span", { className: styles.flavor_option_title, children: full_name }), short_name === "matcha" && _jsx("span", { className: styles.flavor_option_limited, children: "*Limited Edition" }), isProtein ? (_jsx("div", { className: `${styles.flavor_option_amount_wrapper} ${flavorAmount === 0 ? styles.zero_amount : ""} ${out_of_stock && flavorAmount === 0 ? styles.out_of_stock : ""}`, children: flavorAmount === 0 && out_of_stock ? (_jsx("span", { className: styles.out_of_stock_text, children: "Out of Stock" })) : (_jsxs(_Fragment, { children: [_jsx("button", { disabled: flavorAmount === 0, onClick: () => onChangeAmount(false), type: "button", className: styles.flavor_option_amount_button, children: _jsx(Remove, {}) }), _jsx("span", { className: styles.flavor_option_amount, children: flavorAmount }), _jsx("button", { disabled: maxedOut, onClick: () => onChangeAmount(true), type: "button", className: styles.flavor_option_amount_button, children: _jsx(Add, {}) })] })) })) : (_jsx("div", { onKeyUp: selectFlavor, tabIndex: 0, onClick: selectFlavor, role: "button", className: `${styles.flavor_option_select_wrapper} ${flavorAmount !== 0 ? styles.flavor_option_select_wrapper__selected : ""}`, children: "Select" }))] })] }));
};
export default SubscriptionFlavorOption;
